import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {LabelsService} from "../../../labels/services/labels-service.service";
import {SplitService} from "../../../commons/services/split-service.service";

export class OmsPackageListLeanComponent implements IController {

  packages: any;
  packageSizes: any;
  defaultItemSize: any;
  spotDimensions: any;
  spotWeight: number;
  isWeightInTotal: boolean;
  onRemove: Function;
  onPackageChange: Function;

  private packageTypeKeysRef: any;
  private packageTypeKeys: any;
  private labelOptions: any;
  private weightConfig: any;
  private dimensionsConfig: any;
  private packageTypeSearchTerm: any;
  public packageTypeValues: any;
  public sitePackageItemsMap: any;


  constructor(private orderConstants, private labelsService: LabelsService, private splitService: SplitService, private $log) {
  }

  $onInit() {
    this.sitePackageItemsMap = this.splitService.getSitePackageItemsMap();
    this.packageTypeKeys = {};
    this.labelOptions = [];
    this.packageTypeKeysRef = this.orderConstants.packageTypeKeys;
    this.weightConfig = this.splitService.getWeightUnit();
    this.dimensionsConfig = this.splitService.getVolumeUnit();

    if (this.packageSizes && this.packageSizes.length) {
      this.packageTypeValues = _.map(this.packageSizes, (packageSize) => {
        return angular.copy(this.sitePackageItemsMap[packageSize.itemSize]) || {id: packageSize.itemSize};
      })
    }

    if (!this.labelOptions.length) {
      this.labelsService.getAll()
        .then((labels) => {
          this.labelOptions = labels;
        })
        .catch((error) => {
          this.$log.error('Failed to get Label options', error);
        })
    }
    if (!!_.get(this.packages, 'length') && !!this.spotDimensions) {
      _.forEach(this.packages, (p) => {
        if (!p.requiredSpots) {
          this._updatePackageRequiredSpots(p);
        }
      })
    }

    if (this.isWeightInTotal && this.packages?.length) {
      _.forEach(this.packages, (p) => {
        if (p.weight) {
          this._updatePackageTotalWeight(p);
        }
      })
    }
  }

  $onChanges(changes) {
    if (changes.packages && !changes.packages.isFirstChange()) {

      const currenPackages = changes.packages.currentValue,
        previousPackages = changes.packages.previousValue;

      const packagesToAdd = _.difference(currenPackages, previousPackages);

      if (packagesToAdd.length) {
        _.forEach(packagesToAdd, (p) => {
          this._updatePackageRequiredSpots(p);
        })
      }
    }
    if (changes.packageSizes && !changes.packageSizes.isFirstChange()) {
      this.$onInit();
    }
  };

  onCountChange(index, count) {
    this.packages[index].count = count;
    if(this.isWeightInTotal){
      this._updatePackageWeight(this.packages[index]);
      this._updatePackageRequiredSpots(this.packages[index]);
    }
    this.onPackageChange({package: this.packages[index]});
  }

  onPackageTypeChange(item, packageItem) {
    const packageObject = _.find(this.packageSizes, (ps) => {
      return ps.itemSize === item.type;
    });
    if (packageObject) {
      packageItem.labels = packageObject.labels;
      packageItem.dimensions = packageObject.dimensions || {};
      packageItem.weight = packageObject.weight;
    }
    this.onPackageChange({package: item});
  }

  onLabelChanges(labels, packageRef) {
    packageRef.labels = labels;
    this.onPackageChange({package: packageRef});
  }

  onChangeDimensions(packageItem) {
    this._updatePackageRequiredSpots(packageItem);
    this.onPackageChange({package: packageItem});
  }

  onTotalWeightChanged(packageItem) {
    this._updatePackageWeight(packageItem);
    this._updatePackageRequiredSpots(packageItem);
    this.onPackageChange({package: packageItem});
  }

  private _updatePackageRequiredSpots(packageItem) {
    const weightSpots = this.spotsByWeight(_.get(packageItem, 'weight', 0), this.spotWeight)

    const dimensionsSpots = this.spotsByDimensions(
      _.get(packageItem, 'dimensions.width', 0),
      this.spotDimensions.width,
      _.get(packageItem, 'dimensions.length', 0),
      this.spotDimensions.length);

    packageItem.requiredSpots = dimensionsSpots > weightSpots ? dimensionsSpots : weightSpots;
  }

  private spotsByDimensions(inputWidth, settingsWidth, inputLength, settingsLength): number {
    let dimensionsSpots = 0;

    if (settingsWidth && settingsLength) {
      const widthSpots = (inputWidth / settingsWidth) || 0;
      const LengthSpots = (inputLength / settingsLength) || 0;
      dimensionsSpots = Math.ceil(Math.ceil(widthSpots) * Math.ceil(LengthSpots));
    }
    return dimensionsSpots;
  }

  private spotsByWeight(inputWeight, settingsWeight): number {
    return settingsWeight ? Math.ceil(inputWeight / settingsWeight) : 0;
  }

  private _updatePackageTotalWeight(packageRef) {
    packageRef.totalWeight = packageRef.weight * packageRef.count;
  }

  private _updatePackageWeight(packageRef) {
    packageRef.weight = packageRef.totalWeight / packageRef.count;
  }

}

angular
  .module('bringoz.admin.oms')
  .component('omsPackageListLean', {
    bindings: {
      packages: '<',
      packageSizes: '<?',
      defaultItemSize: '<?',
      spotDimensions: '<?',
      spotWeight: '<?',
      onPackageChange: '&',
      onRemove: '&'
    },
    template: require('./oms-package-list-lean.html').default,
    controller: OmsPackageListLeanComponent
  });
